// API Gateway
const env = 'dev';
const APIbaseURL = `https://huu6jds0lk.execute-api.eu-west-1.amazonaws.com/${env}`;

// eslint-disable-next-line import/prefer-default-export
export { APIbaseURL };
